import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { WorkOrderEventLogDialogComponent } from './work-order-event-log-dialog.component';
import { CtModelModule } from '@ctsolution/ct-framework';

/**
 * Modulo per il componente modale dei log eventi WorkOrder
 * Contiene tutte le dipendenze necessarie per il funzionamento del componente
 */
@NgModule({
  declarations: [
    WorkOrderEventLogDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule, // Per le funzionalità della modale (Material Legacy)
    MatButtonModule, // Per il bottone di chiusura (Material Legacy)
    MatIconModule, // Per le icone
    TranslateModule,
    CtModelModule // Per il componente ct-model
  ],
  exports: [
    WorkOrderEventLogDialogComponent
  ]
})
export class WorkOrderEventLogDialogModule { }
